import * as z from "zod";

const ZProgressEnum = z.enum(["RECEIVED", "CREATED", "PROCESSED", "APPROVED", "PARTIALLY_APPROVED", "REJECTED", "UNKNOWN"]);

export const ZClaim = z.object({
   id: z.string(),
   orderNumber: z.string(),
   dateCreated: z.coerce.date().nullable(),
   dateReceived: z.coerce.date().nullable(),
   status: z.object({
      progress: ZProgressEnum,
      errorCode: z.enum(["MANUAL_PROCESSING", "CRM_NOT_RESPONDING"]).nullable()
   }),
   contact: z
      .object({
         companyName: z.string(),
         name: z.string().nullable(),
         email: z.string().nullable(),
         phone: z.string().nullable()
      })
      .nullable(),
   products: z
      .array(
         z.object({
            id: z.string(),
            quantity: z.number(),
            causeCode: z.string().nullable(),
            progress: ZProgressEnum
         })
      )
      .optional()
      .nullable(),
   reasonDescription: z.string().nullable(),
   attachments: z.array(z.string()).nullable()
});
